<template>
  <label
    class="base-checkbox"
    :class="{
      'base-checkbox--reverse': reverse,
      'base-checkbox--label-flex': labelFlex,
    }"
  >
    <input
      v-model="checkedModel"
      type="checkbox"
      class="base-checkbox__input"
      :name="name"
      :value="value"
    />
    <svg viewBox="0 0 100 100">
      <path
        class="box"
        :class="{ 'box--has-error': hasError }"
        d="M82,89H18c-3.87,0-7-3.13-7-7V18c0-3.87,3.13-7,7-7h64c3.87,0,7,3.13,7,7v64C89,85.87,85.87,89,82,89z"
      />
      <path
        class="success-box"
        d="M82,89H18c-3.87,0-7-3.13-7-7V18c0-3.87,3.13-7,7-7h64c3.87,0,7,3.13,7,7v64C89,85.87,85.87,89,82,89z"
      />
      <polyline class="check" points="25.5,53.5 39.5,67.5 72.5,34.5 " />
    </svg>
    <span class="base-checkbox__label">
      <slot />
    </span>
  </label>
</template>

<script>
  export default {
    name: 'BaseCheckbox',
    emits: ['update:modelValue'],
    props: {
      name: {
        type: String,
        required: true,
      },
      modelValue: {
        type: [Array, Boolean],
        required: false,
        default: false,
      },
      value: {
        type: [String, Number, Object, Array],
        required: false,
        default: '',
      },
      reverse: Boolean,
      labelFlex: Boolean,
      hasError: Boolean,
    },
    computed: {
      checkedModel: {
        get() {
          return this.modelValue;
        },
        set(newValue) {
          this.$emit('update:modelValue', newValue);
        },
      },
    },
  };
</script>

<style lang="scss" scoped>
  .base-checkbox {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
    user-select: none;
    margin-bottom: 0;
    width: fit-content;

    &--reverse {
      flex-direction: row-reverse;
    }

    &--label-flex {
      width: 100%;

      .base-checkbox__label {
        width: 100%;
      }
    }

    input[type='checkbox'] {
      display: none;
      pointer-events: none;

      &:checked + svg .success-box {
        stroke-dashoffset: 0;
        transition: stroke-dashoffset 200ms linear;
      }
      &:checked + svg .check {
        stroke-dashoffset: 0;
      }
    }

    svg {
      width: 1.5em;
      stroke: #a7a9ab;
      stroke-width: 5;
      fill: transparent;

      .box {
        stroke-dasharray: 320;
        stroke-dashoffset: 0;
        fill: transparent;
        stroke: #a7a9ab;

        &--has-error {
          stroke: var(--other-red);
        }
      }
      .success-box {
        stroke-dasharray: 320;
        stroke-dashoffset: 320;
        fill: transparent;
        stroke: $green-mid;
        transition: stroke-dashoffset 200ms linear;
      }
      .check {
        stroke-dasharray: 70;
        stroke-dashoffset: 70;
        fill: none;
        stroke: $green-mid;
        transition: stroke-dashoffset 200ms linear;
      }
    }

    &__label {
      width: fit-content;
    }
  }
</style>
